<template>
  <div class="azure-overlay">
    <well class="w-full sm:w-136">
      <h1 class="text-lg font-semibold">{{ $t(`azure.${status}`) }}</h1>
      <LoadingSpinner
        :is-loading="status !== statusMap.error"
        class-names="white mt-4"
      />
      <btn
        v-if="status === statusMap.error"
        class="mt-8 w-full"
        theme="secondary"
        @click="reload"
      >
        {{ $t(`azure.reload`) }}
      </btn>
    </well>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner';
import Well from '@/components/Well/Well';
import Btn from '@/components/Button/Button';
import * as Sentry from '@sentry/vue';
import {
  getUserContextForSentry,
  addUserToSentryScope,
} from '@/util/sentry-user';

export default {
  components: { Well, LoadingSpinner, Btn },
  computed: {
    ...mapState('azure', ['status', 'statusMap']),
  },
  watch: {
    status: {
      immediate: true,
      handler(newStatus) {
        Sentry.addBreadcrumb({
          category: 'azure',
          message: `Azure authentication status changed to: ${newStatus}`,
          level: newStatus === this.statusMap.error ? 'error' : 'info',
          data: {
            status: newStatus,
            timestamp: new Date().toISOString(),
          },
        });

        if (newStatus === this.statusMap.error) {
          Sentry.withScope((scope) => {
            scope.setTag('module', 'azure');
            scope.setTag('action', 'authentication');
            scope.setTag('errorType', 'azure_auth_failed');
            scope.setExtra('status', newStatus);
            scope.setExtra('timestamp', new Date().toISOString());
            scope.setExtra('location', window.location.href);

            const userData = this.$store.state?.user;
            if (userData) {
              const userContext = getUserContextForSentry(userData);
              if (userContext) {
                addUserToSentryScope(scope, userContext);
              }
            }

            const error = new Error('Azure authentication failed');
            Sentry.captureException(error);
          });
        }
      },
    },
  },
  methods: {
    reload() {
      Sentry.addBreadcrumb({
        category: 'azure',
        message: 'User requested Azure authentication reload',
        level: 'info',
        data: {
          previousStatus: this.status,
          timestamp: new Date().toISOString(),
        },
      });

      this.$router.go();
    },
  },
};
</script>
<style scoped>
.azure-overlay {
  @apply bg-white fixed h-screen w-screen top-0 left-0 z-100 p-4 flex flex-col items-center justify-center bg-cover text-primary text-center;
  background-image: url('../../assets/background.png');
}
</style>
